import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export default function Inicio() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([]);
  const [perfil, setPerfil] = useState(null);
  const hoy = format(new Date(), "EEEE d 'de' MMMM", { locale: es });

  useEffect(() => {
    API.get('/app/notificaciones').then(r => setNotifs(r.data.slice(0, 3))).catch(() => {});
    API.get('/app/mi-perfil').then(r => setPerfil(r.data)).catch(() => {});
  }, []);

  const noLeidas = notifs.filter(n => !n.leida).length;

  const esPDV = usuario?.rol === 'punto_venta';
  const esProduccion = usuario?.rol === 'produccion';

  const accesos = esPDV
    ? [
        { label: 'Mi Punto de Venta', icon: '🏪', path: '/pdv', color: '#EFF6FF', border: '#BFDBFE' },
        { label: 'Alertas', icon: '🔔', path: '/notificaciones', color: '#FEF3C7', border: '#FDE68A', badge: noLeidas },
      ]
    : esProduccion
    ? [
        { label: 'Producción', icon: '🏭', path: '/produccion', color: '#F0FDF4', border: '#BBF7D0' },
        { label: 'Alertas', icon: '🔔', path: '/notificaciones', color: '#FEF3C7', border: '#FDE68A', badge: noLeidas },
      ]
    : [
        { label: 'Mi Horario', icon: '📅', path: '/horario', color: '#EFF6FF', border: '#BFDBFE' },
        { label: 'Mis Pagos', icon: '💵', path: '/colillas', color: '#F0FDF4', border: '#BBF7D0' },
        { label: 'Alertas', icon: '🔔', path: '/notificaciones', color: '#FEF3C7', border: '#FDE68A', badge: noLeidas },
        { label: 'Mi Perfil', icon: '👤', path: '/perfil', color: '#F5F3FF', border: '#DDD6FE' },
      ];

  const tipoBg = { info:'#EFF6FF', alerta:'#FEF3C7', error:'#FEF2F2', success:'#F0FDF4' };
  const tipoColor = { info:'#1D4ED8', alerta:'#92400E', error:'#991B1B', success:'#065F46' };

  return (
    <div>
      {/* Saludo */}
      <div style={{ marginBottom:20 }}>
        <div style={{ fontSize:13, color:'#6B7280', textTransform:'capitalize' }}>{hoy}</div>
        <div style={{ fontSize:22, fontWeight:800, color:'#111827', marginTop:2 }}>
          Hola, {usuario?.nombre?.split(' ')[0]} 👋
        </div>
        {perfil?.bodega_nombre && (
          <div style={{ fontSize:13, color:'#6B7280', marginTop:2 }}>📍 {perfil.bodega_nombre}</div>
        )}
      </div>

      {/* Accesos rápidos */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:20 }}>
        {accesos.map(a => (
          <button key={a.path} onClick={() => navigate(a.path)}
            style={{ padding:16, background:a.color, border:`2px solid ${a.border}`, borderRadius:14, cursor:'pointer', textAlign:'left', position:'relative' }}>
            <div style={{ fontSize:24, marginBottom:6 }}>{a.icon}</div>
            <div style={{ fontWeight:700, fontSize:14, color:'#111827' }}>{a.label}</div>
            {a.badge > 0 && (
              <span style={{ position:'absolute', top:10, right:10, background:'#EF4444', color:'white', borderRadius:10, fontSize:11, fontWeight:800, padding:'2px 7px' }}>
                {a.badge}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Últimas alertas */}
      {notifs.length > 0 && (
        <div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
            <div style={{ fontWeight:700, fontSize:15, color:'#111827' }}>Últimas alertas</div>
            <button onClick={() => navigate('/notificaciones')} style={{ background:'none', border:'none', color:'#2563EB', fontSize:13, cursor:'pointer', fontWeight:600 }}>Ver todas</button>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {notifs.map(n => (
              <div key={n.id} onClick={() => navigate('/notificaciones')}
                style={{ background:'white', borderRadius:12, padding:'12px 14px', boxShadow:'0 1px 3px rgba(0,0,0,0.07)', cursor:'pointer', borderLeft:`3px solid ${tipoColor[n.tipo]||'#6B7280'}`, opacity: n.leida ? 0.7 : 1 }}>
                <div style={{ fontWeight: n.leida?500:700, fontSize:13, color:'#111827', marginBottom:2 }}>{n.titulo}</div>
                <div style={{ fontSize:12, color:'#6B7280', lineHeight:1.4 }}>{n.cuerpo.slice(0, 80)}{n.cuerpo.length>80?'...':''}</div>
                <div style={{ fontSize:11, color:'#9CA3AF', marginTop:4 }}>{format(new Date(n.created_at), "d MMM · HH:mm", { locale: es })}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {notifs.length === 0 && (
        <div style={{ textAlign:'center', padding:'40px 20px', color:'#9CA3AF' }}>
          <div style={{ fontSize:40, marginBottom:10 }}>✅</div>
          <div style={{ fontWeight:600 }}>Todo al día</div>
          <div style={{ fontSize:13, marginTop:4 }}>No hay alertas pendientes</div>
        </div>
      )}
    </div>
  );
}
